<template>
  <div class="container" :_webfunny-eo='`{"pointId":8,"appid":"baoH5", "baoGuangYeMian":"包小鉴H5登陆页","uuid":"${wfuuid}"}`'>
    <van-empty v-if="!isSupport" image="error" description="非常抱歉，暂不支持此APP扫码" />
    <div v-if="isSupport">
      <header>
          <!-- <span class="welcome">Welcome</span> -->
          <img src="https://oss.turingsenseai.com/1596794250941895693.png" class="welcome">
      </header>
      <article>
        <div class="phoneName">手机号</div>
        <div class="phoneNumber">
          <input 
            type="text" 
            placeholder='请输入手机号' 
            class="inps1" 
            maxlength="11" 
            v-model="loginForm.phone"  
            oninput="value=value.replace(/[^\d]/g,'');" 
            onafterpaste="value=value.replace(/[^\d]/g,'')" 
            @input="handlePnButton(loginForm); 
            handleLgButton(loginForm)" 
          />
          <!-- 
            @blur="disapper" 
            @focus="appear1"
          -->
          <div 
            v-if="opacity" 
            class="mclear" 
            @click="mclear"
          >
          <!-- 
            :style="{'opacity':opacity}"
          -->
          </div>
        </div>
        <div class="passWordName">验证码</div>
        <div class="passWordNumber">
          <input 
            type="text" 
            placeholder='请输入验证码' 
            class="inps2"
            maxlength="4" 
            v-model="loginForm.sms" 
            oninput="value=value.replace(/[^\d]/g,'')" 
            onafterpaste="value=value.replace(/[^\d]/g,'')"  
            @input="handlePwButton(loginForm); handleLgButton(loginForm)" 
          />
          <!-- 
            @blur="disapper" 
            @focus="appear2"
          -->
          <div 
            class="mclear1" 
            @click="mclear1" 
            v-if="opacity1"
          >
          <!-- 
            :style="{'opacity':opacity1}"
          -->
          </div>
          <button @click="getCode(loginForm)" class="obtainer" :disabled="isDisabled" :style="{'color':color1}">
            <span v-show="show">获取验证码</span>
            <span v-show="!show" class="count" :_webfunny-eo='`{"pointId":9, "appid":"baoH5","baoGuangQuYu":"H5登陆页验证码倒计时","uuid":"${wfuuid}"}`'>{{count}} s</span>
          </button>
        </div>
      </article>
      <footer>
        <div class="loginProtocol">
          登录即同意
          <a href="javascript:void(0);" @click="gotoLinkUser">用户协议</a>
            和
          <a href="javascript:void(0);" @click="gotoLinkPrivacy">隐私政策</a>
          首次登录将自动注册
        </div>
        <div class="login">
          <button class="loginButton" :disabled="isLoginDisabled" :style="{'color':color2, 'background':backgroundColor}" @click="onSubmit">登录</button>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant'
import jsCookies from 'js-cookie'
import { logIn, sendSmsCode, phoneLogin, fetchSMSCode } from '../../common/api/user'
import { getLocationQuery } from '../../common/utils'
const TIME_COUNT = 60
export default {
  name: 'login',
  props: {
    // name: { type: Array, default: () => [] }
  },
  data: function () {
    return {
      isSupport:true,  //扫码进入的路径是否支持
      isDisabled: true,
      isLoginDisabled: true,
      show: true,
      count: '',
      timer: null,
      color1: '#999',
      color2: '#999',
      opacity: 0,
      opacity1: 0,
      backgroundColor: '#EEE',
      loginForm: {
        phone: '',
        sms: '',
      },
    }
  },
  computed: {},
  created(){
    let userAgent=window.navigator.userAgent
    if(userAgent.indexOf('QQ')>0 ||  //QQ
      userAgent.indexOf('AlipayClient')>0          //支付宝             
    ){
      this.isSupport=false
    }
  },
  mounted: function () {},
  // beforeDestroy: function() {},
  watch: {},
  methods: {
    handlePnButton (loginForm) {
      let phLength = this.loginForm.phone.length
      this.opacity = 1
      if (phLength === 11) {
        this.isDisabled = false
        this.color1 = '#1D1D1D'
      }
      if (!phLength) {
        this.opacity = 0
      }
    },
    handlePwButton (loginForm) {
      let smsLength = this.loginForm.sms.length
      this.opacity1 = 1
      if (!smsLength) {
        this.opacity1 = 0
      }
    },
    handleLgButton (loginForm) {
      if (this.loginForm.phone.length === 11 && this.loginForm.sms.length >= 4) {
        this.isLoginDisabled = false
        this.color2 = '#4C668A'
        this.backgroundColor = 'linear-gradient(to right,#a2c5fd,#b9dffc,#c2e9fb)'
      } else {
        this.isLoginDisabled = false
        this.backgroundColor = ''
      }
    },
    getCode (loginForm) {
      if (!/^1[34578]\d{9}$/.test(loginForm.phone)) {
        Toast('手机号不正确')
      } else {
        webfunnyEvent(7).trackEvent({"appid":"baoH5",dianJiNeiRong: 'H5登陆验证码获取',uuid: this.wfuuid});
        fetchSMSCode({ phone: loginForm.phone }).then(result => {
          if (result.errorCode === 0) {
            Toast('验证码已发送')
            if (!this.timer) {
              this.count = TIME_COUNT
              this.show = false
              this.timer = setInterval(() => {
                if (this.count > 0 && this.count <= TIME_COUNT) {
                  this.count--
                } else {
                  this.show = true
                  clearInterval(this.timer)
                  this.timer = null
                }
              }, 1000)
            }
          }
        })
      }
      // 获取手机验证码
      // sendSmsCode({ phone: this.loginForm.phone }).then(result => {
      //   if (result.errorCode === 0) {
      //     this.errorMessage = ''
      //   }
      // })
    },
    onSubmit () {
      webfunnyEvent(7).trackEvent({"appid":"baoH5",dianJiNeiRong: 'H5登陆按钮',uuid: this.wfuuid});
      // 手机号登录
      const { businessId } = getLocationQuery()
      phoneLogin({
        phone: this.loginForm.phone,
        sms: this.loginForm.sms,
        businessId: businessId
      }).then(res => {
        if (res && res.errorCode == 0) {
          webfunnyEvent(10).trackEvent({"appid":"baoH5",xingWeiZhuangTai: 'H5登陆成功',uuid: this.wfuuid});
          jsCookies.set('token', res.token)
          console.log(jsCookies.get('token'))

          const { url, refer, referrer, referUrl } = getLocationQuery()
          const referurl = url || refer || referrer || referUrl // 已经 decode
          console.log(getLocationQuery())
          // referurl && this.$router.replace(referurl)
          window.location.replace(referurl)
        } 
      })
      // logIn({ phone: this.loginForm.phone, sms: this.loginForm.sms }).then(result => {
      //   if (result.errorCode !== 0) return
      //   jsCookies.set('token', result.token)
      //   // 设置 TARO-H5 token-本地存储 (废弃? localStorage 同源策略问题)
      //   // localStorage['token'] = `{"data": '${result.token}'}`
      //   // jsCookies.remove('token')
      //   console.log(jsCookies.get('token'))
      //   const { url, refer, referrer, referUrl } = getLocationQuery()
      //   const referurl = url || refer || referrer || referUrl // 已经 decode
      //   console.log(getLocationQuery())
      //   // referurl && this.$router.replace(referurl)
      //   window.location.replace(referurl)
      //   // this.$router.go(-1)
      // })
    },
    mclear () {
      console.log('opacity')
      this.loginForm.phone = ''
      this.opacity = 0
      this.isLoginDisabled = false
      this.backgroundColor = ''
    },
    mclear1 () {
      console.log('opacity1')
      this.loginForm.sms = ''
      this.opacity1 = 0
      this.isLoginDisabled = false
      this.backgroundColor = ''
    },
    // disapper () {
    //   this.opacity = 0
    //   this.opacity1 = 0
    // },
    // appear1 () {
    //   if (this.loginForm.phone.length > 0) {
    //     this.opacity = 1
    //   }
    // },
    // appear2 () {
    //   if (this.loginForm.sms.length > 0) {
    //     this.opacity1 = 1
    //   }
    // },
    gotoLinkUser () {
      this.$router.push('/static-page/potocol-user')
    },
    gotoLinkPrivacy () {
      this.$router.push('/static-page/potocol-privacy')
    }
  }
}
</script>
<style scoped>
.container{
  min-height: 100vh;
  background-color: #fff;
}
header {
  text-align:center;
  margin:0 auto;
}
header .welcome{
  width:366px;
  height:64px;
  padding-top:83px;
  padding-bottom:91px;
}
article .phoneName{
  font-size: 20px;
  font-family: PingFangSC-Regular;
  color: #1D1D1D;
  letter-spacing: 0;
  text-align: left;
  margin-left:100px;
  margin-bottom:16px;
}
article .phoneNumber{
  text-align:center;
  margin: 0 auto;
  width:550px;
  height:88px;
  margin-bottom:54px;
  position: relative;
}
::-ms-clear{
  display: none;
}
::-ms-reveal{
  display: none;
}
article .inps1{
  width:550px;
  height:88px;
  border: 1px solid #F7F7F7;
  border-radius: 1pt;
  font-family: PingFangSC-Regular;
  color: #1D1D1D ;
  background-color: #F7F7F7;
  font-size: 28px;
  padding-left:40px;
  position: absolute;
  display: block;
  margin: 0 auto;
}
article .phoneNumber .mclear {
  border: 0;
  position: absolute;
  width:34.6px;
  height:34.6px;
  background: url(https://oss.turingsenseai.com/1597024013353436572.png) no-repeat;/*按钮的背景图片  */
  background-size:34.6px 34.6px;/*背景图片的大小*/
  top: 28px;
  left: 472px;
}
article .passWordName{
  font-size: 20px;
  font-family: PingFangSC-Regular;
  color: #1D1D1D;
  letter-spacing: 0;
  text-align: left;
  margin-left:100px;
  margin-bottom:16px;
}
article .passWordNumber{
  text-align:center;
  width: 550px;
  height: 88px;
  margin: 0 auto;
  position: relative;
}
article .passWordNumber .mclear1 {
  border: 0;
  position: absolute;
  width:34.6px;
  height:34.6px;
  background: url(https://oss.turingsenseai.com/1597024013353436572.png) no-repeat;/*按钮的背景图片  */
  background-size:34.6px 34.6px;/*背景图片的大小*/
  top: 28px;
  left: 300px;
}
  article .inps2{
    width:378px;
    height:88px;
    border: 1px solid #F7F7F7;
    border-radius: 1pt;
    font-family: PingFangSC-Regular;
    color: #1D1D1D ;
    background-color: #F7F7F7;
    font-size: 28px;
    padding-left:40px;
  }
  article .obtainer{
    width:172px;
    height:88px;
    color: #999999;
    background-color: #fff;
    font-size: 24px;
    border: none;
    outline:none;
    padding-left: 36px;
  }
  input::-webkit-input-placeholder{
    color:#AAA;
  }
  footer .loginProtocol{
    text-align:center;
    padding-top:140px;
    font-size:20px;
    color:#aaa;
  }
  footer a{
    color:rgb(19, 183, 248);
  }
  footer .login{
    text-align:center;
    padding-top:16px;
  }
  footer .loginButton{
    width:550px;
    height:98px;
    border: 1px solid #EEEEEE;
    background-color:#EEEEEE;
    color:#999;
    font-family: PingFangSC-Medium;
    font-size:34px;
    outline:none;
  }
</style>
